import { useLoaderData } from 'react-router-dom';
import { styled } from 'styled-components';
import EmbeddedQnA from 'components/EmbeddedQnA';
import UFCanvasLogo from 'assets/uf-canvas-beta.svg';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  min-width: 800px;
`;

const Header = styled.header`
  background: linear-gradient(90deg, #314992 0%, #3e5ca2 56%, #5288bb 100%);
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
`;

const Logo = styled.img.attrs({
  src: UFCanvasLogo,
  alt: 'UrbanFootprint Canvas AI Beta',
  width: 318,
  height: 25,
})`
  margin-left: 20px;
`;

const Footer = styled.footer`
  color: #9398b1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto Mono', monospace;
  font-size: 11px;
  font-weight: bold;
  background-color: #e8eff8;
  width: 100%;
  height: 40px;
`;

/**
 * The top-level component for the application
 *
 * @returns {JSX.Element} - the dashboard
 */
export default function CanvasAI() {
  const { embed_url: url } = useLoaderData();

  return (
    <Page>
      <Header>
        <Logo />
      </Header>
      <EmbeddedQnA
        placeholder="What parcels are you looking for?"
        title="Ask a question about our parcel canvas for CA, TX, FL, and OH"
        url={url}
      />
      <Footer>
        To download your result, hover over the table and click the menu button
        (&#8942;), then choose &ldquo;Export to CSV&rdquo;. Upload the CSV to an
        UrbanFootprint project for maps and further analysis.
      </Footer>
    </Page>
  );
}
